import { Logo } from "./Buttons";
import { PHONE_DISPLAY, PHONE_TEL, EMAIL, WA_LINK } from "../lib/site";

export default function Footer() {
    return (
        <footer className="relative border-t border-white/5 bg-panel/60 pb-24 md:pb-0" data-testid="site-footer">
            <div className="max-w-7xl mx-auto px-5 md:px-8 py-14 grid gap-10 md:grid-cols-3">
                <div>
                    <Logo />
                    <p className="mt-5 text-sm text-ash leading-relaxed max-w-xs">
                        Impermeabilizzazioni e coperture edili. Terrazzi, lastrici solari,
                        guaine e resine — l&rsquo;acqua resta fuori.
                    </p>
                </div>
                <nav className="flex flex-col gap-3" data-testid="footer-nav">
                    <span className="font-mono2 text-[10px] uppercase tracking-[0.22em] text-ash/70">Naviga</span>
                    {[
                        ["#servizi", "Servizi"],
                        ["#lavori", "Lavori"],
                        ["#azienda", "Azienda"],
                        ["#contatti", "Contatti"],
                    ].map(([href, label]) => (
                        <a key={href} href={href} data-testid={`footer-link-${href.slice(1)}`} className="text-sm text-ash hover:text-cloud transition-colors w-fit">
                            {label}
                        </a>
                    ))}
                </nav>
                <div className="flex flex-col gap-3">
                    <span className="font-mono2 text-[10px] uppercase tracking-[0.22em] text-ash/70">Contatti</span>
                    <a href={`tel:${PHONE_TEL}`} data-testid="footer-phone" className="text-sm text-ash hover:text-cloud transition-colors w-fit">
                        {PHONE_DISPLAY}
                    </a>
                    <a href={`mailto:${EMAIL}`} data-testid="footer-email" className="text-sm text-ash hover:text-cloud transition-colors w-fit">
                        {EMAIL}
                    </a>
                    <a href={WA_LINK} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp" className="text-sm text-wa hover:brightness-110 transition w-fit">
                        WhatsApp diretto →
                    </a>
                </div>
            </div>
            <div className="border-t border-white/5">
                <p className="max-w-7xl mx-auto px-5 md:px-8 py-6 font-mono2 text-[10px] uppercase tracking-[0.2em] text-ash/50">
                    © {new Date().getFullYear()} Edil Loffredo — Impermeabilizzazioni & Coperture Edili
                </p>
            </div>
        </footer>
    );
}
